import {HasProduct, withProduct} from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {getCurrentCartState} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import {connect} from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const cartState = getCurrentCartState(state);
    const cart = cartState.value;

    return {
        cart,
        isAuthenticated: state.context.session.isAuthenticated,
    };
};

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const CurrentCartQuantity: React.FC<Props> = ({ product, cart }) => {
    const cartItem = cart?.cartLines?.find((cartLine) => cartLine.productId === product.id);

    return cartItem ?
        <Typography
            style={{ paddingTop: 5, paddingBottom: 5}}
            transform='capitalize'
        >
            You currently have {cartItem.qtyOrdered} in your cart
        </Typography> : <></>
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(CurrentCartQuantity)),
    definition: {
        displayName: "Current Cart Quantity",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;